export interface RoleInterface {
  id :number;
  name :string;
  baserole :number;
  permissions ?:any[]; // TODO
}

export enum Roles {
  SUPER_ADMIN_CODE = 99,
  ADMIN_CODE = 88,
  FACTORY_ADMIN_CODE = 8,
  SALES_MEMBER_CODE = 2,
  STAFF_CODE = 1,
}
